module.exports = __webpack_public_path__ + "static/img/3.94a40cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/3.png
// module id = TzWK
// module chunks = 0